import { Component, input, output } from '@angular/core';

/**
 * Promotional entry-point card inviting fund holders into the Promotional Tools settings
 * page (Donate Now / Media Kit Templates / QR Code Generator). Its "Explore" button is the
 * card's single activation target.
 *
 * @example
 * ```html
 * <app-promotional-tools-card (clicked)="onPromotionalToolsClicked()"></app-promotional-tools-card>
 * ```
 */
@Component({
  selector: 'app-promotional-tools-card',
  standalone: false,
  templateUrl: './promotional-tools-card.component.html',
  styleUrls: ['./promotional-tools-card.component.scss'],
})
export class PromotionalToolsCardComponent {
  /**
   * Translation key for the "new feature" ribbon badge.
   */
  badgeKey = input<string>('fund.promotional_tools_card.badge');

  /**
   * Translation key for the card title.
   */
  titleKey = input<string>('fund.promotional_tools_card.title');

  /**
   * Translation key for the card description.
   */
  descriptionKey = input<string>('fund.promotional_tools_card.description');

  /**
   * Translation key for the call-to-action button label.
   */
  ctaLabelKey = input<string>('fund.promotional_tools_card.cta_label');

  /**
   * Whether the "new feature" ribbon badge is visible.
   */
  showBadge = input<boolean>(true);

  /**
   * Emitted when the call-to-action button is activated (click or Enter/Space).
   */
  clicked = output<void>();

  onClick(): void {
    this.clicked.emit();
  }
}
